import {IModule} from "../BackendFacade/IModuleInstances";
import {Module as DOOPModule, moduleContent as DOOP} from "../Components/DOOP";
import {Module as DOOPDevModule, moduleContent as DOOPDev} from "../Components/DOOPDev";
import {Module as DPASModule, moduleContent as DPAS} from "../Components/DPAS";
import {Module as IDMSModule, moduleContent as IDMS} from "../Components/IDMS";
import {Module as IDMSDevModule, moduleContent as IDMSDev} from "../Components/IDMSDev";
import {Module as GithubModule, moduleContent as Github} from "../Components/Github";

import {moduleContent as AppStoreConnect} from "../Components/AppleStoreConnect";
import {moduleContent as AzureDevOps} from "../Components/AzureDevOps";
import {moduleContent as AzurePortal} from "../Components/AzurePortal";
import {moduleContent as Blackduck} from "../Components/Blackduck";
import {moduleContent as BookmarkModule} from "../Components/BookmarkModule";
import {Module as DAMSModule, moduleContent as DAMS} from "../Components/DAMS";
import {moduleContent as Firebase} from "../Components/Firebase";
import {moduleContent as GoogleCloudServices} from "../Components/GoogleCloudServices";
import {moduleContent as GooglePlay} from "../Components/GooglePlay";
import {moduleContent as KeyChanger} from "../Components/KeyChanger";
import {moduleContent as Sendgrid} from "../Components/Sendgrid";
import {moduleContent as SentryIO} from "../Components/SentryIO";
import {moduleContent as Sonarqube} from "../Components/Sonarqube";
import {moduleContent as Hub} from "../Components/Hub";
import {moduleContent as ProjectContent,} from "../Components/ProjectContent";
import {moduleContent as TestFairy} from "../Components/TestFairy";

import {IListOfModules} from "../HubFramework/IHub";
import ProjectContentModule from "../Components/ProjectContent/module";
import HubModule from "../Components/Hub/module";
import BookmarkModuleModule from "../Components/BookmarkModule/module";
import TestFairyModule from "../Components/TestFairy/module";
import AppStoreConnectModule from "../Components/AppleStoreConnect/module";
import AzureDevOpsModule from "../Components/AzureDevOps/module";
import AzurePortalModule from "../Components/AzurePortal/module";
import BlackduckModule from "../Components/Blackduck/module";
import FirebaseModule from "../Components/Firebase/module";
import GoogleCloudServicesModule from "../Components/GoogleCloudServices/module";
import GooglePlayModule from "../Components/GooglePlay/module";
import KeyChangerModule from "../Components/KeyChanger/module";
import SendgridModule from "../Components/Sendgrid/module";
import SentryIOModule from "../Components/SentryIO/module";
import SonarqubeModule from "../Components/Sonarqube/module";


export const getListOfAllModules = function (): IListOfModules {
    let obj: IListOfModules = {};
    obj[DOOP.moduleName] = {moduleContent: DOOP, Module: DOOPModule}
    obj[DOOPDev.moduleName] = {moduleContent: DOOPDev, Module: DOOPDevModule}
    obj[DPAS.moduleName] = {moduleContent: DPAS, Module: DPASModule}
    obj[IDMS.moduleName] = {moduleContent: IDMS, Module: IDMSModule}
    obj[IDMSDev.moduleName] = {moduleContent: IDMSDev, Module: IDMSDevModule}
    obj[Github.moduleName] = {moduleContent: Github, Module: GithubModule}
    obj[TestFairy.moduleName] = {moduleContent: TestFairy, Module: TestFairyModule}
    obj[AppStoreConnect.moduleName] = {moduleContent: AppStoreConnect, Module: AppStoreConnectModule}
    obj[AzureDevOps.moduleName] = {moduleContent: AzureDevOps, Module: AzureDevOpsModule}
    obj[AzurePortal.moduleName] = {moduleContent: AzurePortal, Module: AzurePortalModule}
    obj[Blackduck.moduleName] = {moduleContent: Blackduck, Module: BlackduckModule}
    obj[BookmarkModule.moduleName] = {moduleContent: BookmarkModule, Module: BookmarkModuleModule}
    obj[DAMS.moduleName] = {moduleContent: DAMS, Module: DAMSModule}
    obj[Firebase.moduleName] = {moduleContent: Firebase, Module: FirebaseModule}
    obj[GoogleCloudServices.moduleName] = {moduleContent: GoogleCloudServices, Module: GoogleCloudServicesModule}
    obj[GooglePlay.moduleName] = {moduleContent: GooglePlay, Module: GooglePlayModule}
    obj[KeyChanger.moduleName] = {moduleContent: KeyChanger, Module: KeyChangerModule}
    obj[Sendgrid.moduleName] = {moduleContent: Sendgrid, Module: SendgridModule}
    obj[SentryIO.moduleName] = {moduleContent: SentryIO, Module: SentryIOModule}
    obj[Sonarqube.moduleName] = {moduleContent: Sonarqube, Module: SonarqubeModule}
    obj[Hub.moduleName] = {moduleContent: Hub, Module: HubModule}
    obj[ProjectContent.moduleName] = {moduleContent: ProjectContent, Module: ProjectContentModule}
    return obj
}

/**
 * Returns true if the module is not an internal module
 * @param module module instance
 */
export const isExternalModule = function (module: IModule): boolean {
    const internalModules = [DOOP.moduleName, DPAS.moduleName, IDMS.moduleName, IDMSDev.moduleName, DOOPDev.moduleName, Github.moduleName];
    return !internalModules.includes(module.staticModuleId);
}
